const updates = [
  { date: '07-31', title: '星际迷航：新纪元 4K修复版上线', tag: '新上线' },
  { date: '07-30', title: '极限挑战第十季最新期已更新', tag: '综艺更新' },
  { date: '07-29', title: '长安十二时辰全集开放免费观看', tag: '限时开放' },
  { date: '07-28', title: '2026夏季新番追番指南专题发布', tag: '专题上线' },
  { date: '07-27', title: '服务器全面升级，播放体验再提速', tag: '平台公告' },
  { date: '07-26', title: '流浪地球3 超清预告片独家上线', tag: '预告首发' },
  { date: '07-25', title: '进击的巨人终章完整版已更新完毕', tag: '完结上线' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          平台更新与内容上线的第一手资讯
        </p>

        <div className="max-w-3xl mx-auto">
          {updates.map((u, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-4 border-b border-background-200/60 last:border-b-0 group cursor-pointer"
            >
              <div className="flex-shrink-0 w-14 pt-0.5">
                <span className="text-xs font-mono font-medium text-foreground-400 bg-secondary-50 px-2 py-1 rounded whitespace-nowrap">
                  {u.date}
                </span>
              </div>
              <div className="flex-1 min-w-0 flex items-center gap-3 flex-wrap">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                  {u.title}
                </h3>
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                  {u.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}